import React , {useState,useEffect} from 'react'
import { useForm } from "react-hook-form";
import clinicService from "../../../../../services/clinic.service";
import {toast} from 'react-toastify'
import { useParams } from 'react-router-dom';
function AddDayForm({hof,updateHours}) {
    const [addNew,setAddNew] = useState(false)
    const {clinicId} = useParams()
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm()
    const onSubmit = (data)=>{
        //console.log(data)
        const st= data.status === '1'?1:0
        data.status = st
        let newHof = hof 
        newHof.push(data)
        //console.log(newHof)
        clinicService.updateHours(clinicId,newHof)
        .then(res=>{
            updateHours(res.data)
            toast.success("Day Added Successfull",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            setAddNew(!addNew)
        })
        .catch(err=>{
            toast.error("Error while adding Day",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })

    }
    
  return (
    <>
        {!addNew ? <div><button className='btn btn-success' onClick={()=>setAddNew(!addNew)}>Add New Day</button></div>:
    
    <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-3 col-md-3">
              
                <select 
                  className="form-select"
                  {...register("day")}
                  >
                    <option value="MONDAY" >Monday</option>
                    <option value="TUESDAY" >Tuesday</option>
                    <option value="WEDNESDAY" >Wednesday</option>
                    <option value="THURSDAY">Thursday</option>
                    <option value="FRIDAY" >Friday</option>
                    <option value="SATURDAY" >Saturday</option>
                    <option value="SUNDAY" >Sunday</option>
                  </select>
             
            </div>
            <div className="col-lg-3 col-md-3 d-flex justify-content-center align-item-center">
              <input 
                type="text"
                className="form-control me-2"
                placeholder="Start"
                {...register("start")}
                />
                
                <input 
                type="text"
                placeholder="End"
                className="form-control"
                {...register("end")}
                />
            </div>
            <div className="col-lg-2 col-md-2">
              <select
                  className="form-select"
                  {...register("status")}
                  >
                    <option value="1">Open</option>
                    <option value="0">Closed</option>
                  </select>
           
            </div>
            <div className="col-lg-2 col-md-2">
              <input 
                type="text"
                className="form-control"
                placeholder="Note"
                {...register("note")}
                />
           
            </div>
          <div className="col-lg-2 col-md-2 d-flex align-items-center">
            <button className="btn btn-sm btn-success me-2" type="submit">Save</button>
            </div>
          </form>
}
</>
  )
}

export default AddDayForm